// import TMSLogo from "assets/TMS 2-8.png";

// export const canTmsMeta = {
//   title: "CAN TMS",
//   description: "Nepal Can Transport Management System",
//   "og:image": TMSLogo,
//   "og:summary_large_image": TMSLogo,
// };


import TMSLogo from "assets/tcbtms.png";

export const canTmsMeta = {
  title: "CAN TMS",
  description: "Nepal Can Transport Management System",
  "og:image": TMSLogo,
  "og:image:width": "1200", 
  "og:image:height": "630",   
  "og:summary_large_image": TMSLogo,
};
